import $ from 'jquery';
class MenuIcon {

    constructor(){
        this.events(); 
    }

    events() {
        $("#dys-menu-icon").on("click", this.menuClick.bind(this));
        $("#dys-menu-close").on("click", this.menuCloseClick.bind(this));
    }

    //  Methods
    menuClick(e){
        $("#dys-menu-icon").hide();
        $("#dys-menu-close").css('display', 'block');
        $(".mask").height($(document).height());
        $(".mask").show();
        $('body').css('overflow', 'hidden');
        $(".mobile-menu").show();
    }
    menuCloseClick(e){
        $("#dys-menu-icon").show();
        $("#dys-menu-close").hide();
        $(".mobile-menu").hide();
        $(".mask").hide();
        $('body').css('overflow','');
    }
}
export default MenuIcon;